//Reducer Types
interface State {
  teamMemberList: any;
  teamMemberCount: number;
  teamMemberDetails?: any;
  createdByList: any;
  pricesheetHistory: any;
  pricesheetDetails:any;
  employeeDetails?: any;
}

export const teamMemberReducer = (
  state: State = {
    teamMemberList: [],
    teamMemberCount: 0,
    teamMemberDetails: null,
    createdByList: [],
    pricesheetHistory: [],
    pricesheetDetails:null,
    employeeDetails: null,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_TEAM_MEMBER_LIST":
      return {
        ...state,
        teamMemberList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.teamMemberList, ...action.payload?.data],
        teamMemberCount: action.payload.count,
      };
    case "UPDATE_TEAM_MEMBER_DATA":
      return {
        ...state,
        teamMemberList: state?.teamMemberList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
        teamMemberDetails:
          state?.teamMemberDetails?._id == action?.payload?._id
            ? action?.payload
            : state?.teamMemberDetails,
      };
    case "DELETE_TEAM_MEMBER":
      return {
        ...state,
        teamMemberList: state?.teamMemberList?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        teamMemberCount: state?.teamMemberCount - 1,
      };
    case "GET_TEAM_MEMBER_FILTER_DATA":
      return {
        ...state,
        createdByList: action?.payload,
      };

    case "GET_TEAM_MEMBER_DETAILS":
      return {
        ...state,
        teamMemberDetails: action.payload,
      };
    case "GET_EMPLOYEE_DETAILS":
    case "UPDATE_EMPLOYEE_DETAILS":
      return {
        ...state,
        employeeDetails: action.payload,
      };
    case "CLEAR_TEAM_MEMBER_ARRAY":
      return {
        ...state,
        teamMemberList: [],
      };
    case "GET_PRICESHEET_HISTORY_DATA":
      return {
        ...state,
        pricesheetHistory:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.pricesheetHistory, ...action.payload?.data],

        pricesheetDetails: action.payload.pricesheet
      };
    default:
      return state;
  }
};
